var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "warning_svg__warning-icon",
    d: "M12.752 3.186l7.618 13.85A2 2 0 0118.617 20H3.383a2 2 0 01-1.753-2.964l7.618-13.85a2 2 0 013.504 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "warning_svg__warning-line",
    width: 3,
    height: 7.5,
    x: 9.5,
    y: 10.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "warning_svg__warning-line",
    width: 3,
    height: 3,
    x: 9.5,
    y: 6,
    rx: 1,
    transform: "matrix(1 0 0 -1 0 15)"
  }))));
}
export default SvgWarning;